import { render, staticRenderFns } from "./ChangeChip.vue?vue&type=template&id=98c9fc84"
import script from "./ChangeChip.vue?vue&type=script&lang=js"
export * from "./ChangeChip.vue?vue&type=script&lang=js"
import style0 from "./ChangeChip.vue?vue&type=style&index=0&id=98c9fc84&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports